import { wibClock } from "../lib/history";

/**
 * Bits shared by the board-history pages (charger, teras): the palette, tooltips
 * and legend. Light/dark steps live in CSS so the SVG follows Tailwind's `dark`
 * class rather than a JS media query.
 */
// Categorical slots 1-3 + status-ish stage tints. Light/dark steps live in CSS
// so the SVG follows Tailwind's `dark` class rather than a JS media query.
export const HIST_CSS = `
.hist{--c1:#2a78d6;--c2:#eb6834;--c3:#1baf7a;--c4:#eda100;--c5:#e34948;--c6:#8e5bd6;--grid:rgba(120,120,120,.22);--ink:#52514e}
.dark .hist{--c1:#3987e5;--c2:#d95926;--c3:#199e70;--c4:#c98500;--c5:#e66767;--c6:#a67ae6;--ink:#c3c2b7}
.hist .recharts-cartesian-axis-tick-value{fill:var(--ink)}
`;

/** Charger stage `g` -> name + background tint. */
export const STAGE: Record<number, { name: string; color: string }> = {
  0: { name: "OFF", color: "#8a8a8a" },
  1: { name: "BULK", color: "#2a78d6" },
  2: { name: "ABSORB", color: "#eda100" },
  3: { name: "FLOAT", color: "#1baf7a" },
};

export interface Marker {
  t: number;
  y: number;
  title: string;
  lines: string[];
}

export const hhmm = (t: number) => wibClock(t).slice(0, 5);

export function Tip({
  active,
  payload,
  label,
  fmt,
}: {
  active?: boolean;
  payload?: any[];
  label?: number;
  fmt: Record<string, [string, string, number]>;
}) {
  if (!active || !payload?.length) return null;
  const rows = payload.filter((p) => fmt[p.dataKey] && p.value !== undefined);
  if (!rows.length) return null;
  return (
    <div className="rounded border border-slate-500/50 bg-white dark:bg-slate-800 px-2 py-1 text-xs shadow">
      <div className="font-semibold">{wibClock(label as number)} WIB</div>
      {rows.map((p) => (
        <div key={p.dataKey}>
          {fmt[p.dataKey][0]}: {Number(p.value).toFixed(fmt[p.dataKey][2])}{" "}
          {fmt[p.dataKey][1]}
        </div>
      ))}
    </div>
  );
}

export function MarkerTip({ active, payload }: { active?: boolean; payload?: any[] }) {
  const m: Marker | undefined = active ? payload?.[0]?.payload : undefined;
  if (!m) return null;
  return (
    <div className="rounded border border-slate-500/50 bg-white dark:bg-slate-800 px-2 py-1 text-xs shadow">
      <div className="font-semibold">
        {wibClock(m.t)} WIB · {m.title}
      </div>
      {m.lines.map((l, i) => (
        <div key={i}>{l}</div>
      ))}
    </div>
  );
}

export function Legend({ items }: { items: Array<[string, string]> }) {
  return (
    <div className="flex flex-wrap gap-x-4 text-xs opacity-80 px-1">
      {items.map(([color, label]) => (
        <span key={label}>
          <span
            className="inline-block w-3 h-0.5 mr-1 align-middle"
            style={{ background: color, height: 3 }}
          />
          {label}
        </span>
      ))}
    </div>
  );
}
